import { RangeOperationDialog } from '@/components/edit/range-operation-dialog'

export interface RemoveGpsOnlyDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/** Clears GPS position from records in the chosen range, keeping heart rate/cadence/etc. and the records themselves. */
export function RemoveGpsOnlyDialog({ open, onOpenChange }: RemoveGpsOnlyDialogProps) {
  return (
    <RangeOperationDialog
      open={open}
      onOpenChange={onOpenChange}
      idPrefix="remove-gps-only"
      title="Remove GPS only"
      description="Clears GPS position from records in this range -- other metrics (heart rate, cadence, power, etc.) and the records themselves are kept. Use this for a GPS dropout you'd rather hide than keep as-is."
      confirmLabel="Remove GPS"
      buildOperation={(start, end) => ({ type: 'removeGpsOnly', start, end })}
    />
  )
}
